import React from 'react';

import { useDeleteCategory } from 'scenes/Influencers/InfluencersChannels/data';

import Actions from './Actions';

const CategoryActions = ({ actions, data, onEdit, onDelete }) => {
  const [deleteCategory] = useDeleteCategory();

  const handleDelete = async () => {
    await deleteCategory({ id: data.id, name: data.name });
    if (onDelete) {
      await onDelete();
    }
  };

  const handleEdit = () => onEdit?.(data);

  return (
    <Actions actions={actions} onDelete={handleDelete} onEdit={handleEdit} />
  );
};

export default CategoryActions;
